import * as z from "zod/v4";

export const getDefaultSenderAddressForTeam = {
  name: "getDefaultSenderAddressForTeam" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ name: z.string(), email: z.string(), domain: z.string() }),
};
